import { useAuthAppStore } from "@/store/stores/authStore"
import { ErrorMessageService } from "@/services/errorMessageService/errorMessageService";

export class CostCentreService {

  async getAllEntities({
    costCentreServiceClient
  }) {

    var response = await costCentreServiceClient.get({
      route: "/cost-center/get-all-entities",
      // params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getAllEntitiesPaged({
    costCentreServiceClient, params
  }) {

    var response = await costCentreServiceClient.get({
      route: "/cost-center/get-all-entities-paged",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        "Authorization": `Bearer ${useAuthAppStore().token}`
      }
    });

    return response;
  }

  async putEntities({ client, data, successCallback, errorCallback }) {
    await client.put({
      route: "/cost-center/update-entity",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }

  async setExport(filters, cproxServiceClient) {
    try {
      const response = await cproxServiceClient.finance.post({
        data: {
          Filters: filters,
        },
        route: "/cost-center/download-entities",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Content-Type": "application/json",
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });

      if (response && response.status) {
        return response;
      } else {
        throw new Error("Invalid response from ContainerService");
      }
    } catch (error) {
      if (error.isAxiosError) {
        this._sweetAlertService.showAlert(
          "Error",
          error.response?.data?.ResponseStatus?.Errors?.length
            ? error.response.data.ResponseStatus.Errors.map(
                (e) => e.Message
              ).join("\n")
            : (
              (new ErrorMessageService()).getUserMessage({ errorCode: error.response?.data?.ResponseStatus?.errorCode, message: error.response?.data?.ResponseStatus?.Message })
            ),
          "error"
        );
      } else {
        console.error("Unexpected error from import-entities-with-file", error);
        throw error;
      }
    }
  }

  async setImport(
    file,
    deleteNotInFile,
    cproxServiceClient,
    fileManagerService
  ) {
    try {
      const convertedFile = await fileManagerService.convertToByteArray(file);

      const response = await cproxServiceClient.finance.post({
        data: {
          File: JSON.stringify(Array.from(convertedFile)),
          DeleteNotInFile: deleteNotInFile,
        },
        route: "/cost-center/import-entities",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Content-Type": "application/json",
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });

      if (response && response.status) {
        return response;
      } else {
        throw new Error("Invalid response from ContainerService");
      }
    } catch (error) {
      if (error.isAxiosError) {
        this._sweetAlertService.showAlert(
          "Error",
          error.response?.data?.ResponseStatus?.Errors?.length
            ? error.response.data.ResponseStatus.Errors.map(
                (e) => e.Message
              ).join("\n")
            : (
              (new ErrorMessageService()).getUserMessage({ errorCode: error.response?.data?.ResponseStatus?.errorCode, message: error.response?.data?.ResponseStatus?.Message })
            ),
          "error"
        );
      } else {
        console.error("Unexpected error from import-entities-with-file", error);
        throw error;
      }
    }
  }

  async createEntities({ client, data, successCallback, errorCallback }) {
    await client.post({
      route: "/cost-center/create-entity",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      data: data,
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
  }

  async deleteEntity({ client, params, successCallback, errorCallback }) {      
      await client.delete({
        route: "/cost-center/delete-entity",
        params: params,
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Authorization": `Bearer ${useAuthAppStore().token}`
        },
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
  }

  async getFindCosCentersByDepartmentCode({
    costCentreServiceClient,
    params
  }) {

    var response = await costCentreServiceClient.get({
      route: "/cost-center/find-cost-centers-by-department-code",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getFindByUserSession({
    costCentreServiceClient
  }) {

    var response = await costCentreServiceClient.get({
      route: "/cost-center/find-by-user-session",
      // params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getCostCenterEntityByPKey({
    costCentreServiceClient,
    params
  }) {

    var response = await costCentreServiceClient.get({
      route: "/cost-center/get-entity-by-pkey",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getCostCenterEntityByCode({
    costCentreServiceClient,
    params
  }) {

    var response = await costCentreServiceClient.get({
      route: "/cost-center/find-cost-center-by-code",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getDepartmentEntityByCode({
    costCentreServiceClient,
    params
  }) {

    var response = await costCentreServiceClient.get({
      route: "/department/get-entity-by-code",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getDepartments({
    costCentreServiceClient
  }) {

    var response = await costCentreServiceClient.get({
      route: "/department/get-all-entities",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }
  

}
